import { render, staticRenderFns } from "./PostMortemSlide.vue?vue&type=template&id=9375d15c"
import script from "./PostMortemSlide.vue?vue&type=script&lang=js"
export * from "./PostMortemSlide.vue?vue&type=script&lang=js"
import style0 from "./PostMortemSlide.vue?vue&type=style&index=0&id=9375d15c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports